module.exports = __webpack_public_path__ + "img/Bodice-Back-Jc-Kd-Lb.df9f14b3.png";